/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2018, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define(
    'src/adapter/services/Instantiate',['../../../platform/core/src/objects/DomainObjectImpl'],
    function (DomainObjectImpl) {

        /**
         * Overrides platform version of instantiate, passes Id with model such
         * that capability detection can utilize new format domain objects.
         */
        function Instantiate(
            capabilityService,
            identifierService,
            cacheService
        ) {
            return function (model, id) {
                id = id || identifierService.generate();
                var old_id = model.id;
                model.id = id;
                var capabilities = capabilityService.getCapabilities(model, id);
                model.id = old_id;
                cacheService.put(id, model);
                return new DomainObjectImpl(id, model, capabilities);
            };
        }

        return Instantiate;
    }
);

